var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.item)?_c('span',{staticClass:"saving-notification d-flex align-center"},[_c('b',[_vm._v("Предложение: ")]),_vm._v(" "+_vm._s(_vm.item)+" "),_vm._t("default",null,{"saving":_vm.saving,"remainder":_vm.remainder})],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }